import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PredefinedDateRangePicker from "../../../controls/PredefinedDateRangePicker";
import ActionLink from "../../../controls/ActionLink";
import BackEnd from "../../../backend/BackEnd";
import AddressSelector from "../../../controls/AddressSelector";
import moment from "moment";
import ClientDropdown from "../../../controls/ClientDropdown";
import ProductsModal from "../modals/ProductsModal";

class SearchForm extends Component {
    static propTypes = {
        showClientCompany: PropTypes.bool,
        showAdvertsOnly: PropTypes.bool,
        onChange: PropTypes.func
    };
    static defaultProps = {
        showClientCompany: false,
        showAdvertsOnly: false
    };
    state = {
        typeId: null,
        region: {},
        showProductsModal: false,
        products: [],
        isPickupOnly: false,
        clientCompany: '',
        selectedProducts: [],
        showUsedProducts: false,
        showNewProducts: false,
        minPrice: '',
        maxPrice: '',
        minCount: '',
        maxCount: '',
        startDate: moment().startOf('year').format(),
        endDate: moment().endOf('year').format(),
        isAdvertsOnly: false
    };

    async componentDidMount() {
        let getProducts = new BackEnd.Products.GetProducts();
        let products = await getProducts.call();

        this.setState({products});
    }

    render() {
        return (
            <div className="panel box" id="search-form">
                <div className="box-row">
                    <div className="box-cell p-x-2 p-y-1 bg-black text-xs-center font-size-11 font-weight-semibold">
                        <i className="fa fa-search"/>&nbsp;&nbsp;Поиск
                    </div>
                </div>
                <div className="box-row">
                    <form className="panel-body">
                        <fieldset className="form-group">
                            <AddressSelector className="form-control" placeholder="Любой город или регион"
                                             precision="region"
                                             value={this.state.region}
                                             onChange={region => this.updateCriteria({region})}/>
                        </fieldset>
                        <fieldset className="form-group">
                            <label className="custom-control custom-checkbox checkbox-inline">
                                <input type="checkbox" className="custom-control-input"
                                       checked={this.state.isPickupOnly}
                                       onChange={event => this.updateCriteria({isPickupOnly: event.target.checked})}/>
                                <span className="custom-control-indicator"/> Только самовывоз
                            </label>
                        </fieldset>
                        <fieldset className="form-group">
                            <ClientDropdown className="form-control" multiple
                                            placeholder="Выберите тип(-ы) поддонов..."
                                            items={this.state.products}
                                            value={this.state.selectedProducts}
                                            onChange={(_, values) => this.updateCriteria({selectedProducts: values})}/>
                            <small className="text-muted">
                                Вы также можете
                                {' '}
                                <ActionLink className="text-underlined"
                                            onClick={() => this.setState({showProductsModal: true})}>
                                    посмотреть спецификации
                                </ActionLink>
                                {' '}
                                на продукцию.
                            </small>
                        </fieldset>
                        <fieldset className="form-group">
                            <label className="custom-control custom-checkbox checkbox-inline">
                                <input type="checkbox" className="custom-control-input"
                                       checked={this.state.showUsedProducts}
                                       onChange={event => this.updateCriteria({showUsedProducts: event.target.checked})}/>
                                <span className="custom-control-indicator"/> Б/У
                            </label>
                            <label className="custom-control custom-checkbox checkbox-inline m-l-4">
                                <input type="checkbox" className="custom-control-input"
                                       checked={this.state.showNewProducts}
                                       onChange={event => this.updateCriteria({showNewProducts: event.target.checked})}/>
                                <span className="custom-control-indicator"/> Новые
                            </label>
                        </fieldset>
                        <fieldset className="form-group">
                            <div className="input-group">
                                <div className="input-group-addon">Цена</div>
                                <input type="number" className="form-control" placeholder="От"
                                       value={this.state.minPrice}
                                       onChange={event => this.updateCriteria({minPrice: event.target.value})}/>
                                <div className="input-group-addon">&mdash;</div>
                                <input type="number" className="form-control" placeholder="До"
                                       value={this.state.maxPrice}
                                       onChange={event => this.updateCriteria({maxPrice: event.target.value})}/>
                                <div className="input-group-addon">р./шт.</div>
                            </div>
                        </fieldset>
                        <fieldset className="form-group">
                            <div className="input-group">
                                <div className="input-group-addon">Кол-во</div>
                                <input type="number" className="form-control" placeholder="От"
                                       value={this.state.minCount}
                                       onChange={event => this.updateCriteria({minCount: event.target.value})}/>
                                <div className="input-group-addon">&mdash;</div>
                                <input type="number" className="form-control" placeholder="До"
                                       value={this.state.maxCount}
                                       onChange={event => this.updateCriteria({maxCount: event.target.value})}/>
                                <div className="input-group-addon">шт.</div>
                            </div>
                        </fieldset>
                        {
                            this.props.showClientCompany &&
                            <fieldset className="form-group">
                                <input type="text" className="form-control"
                                       placeholder="Введите часть названия клиента"
                                       value={this.state.clientCompany}
                                       onChange={event => this.updateCriteria({clientCompany: event.target.value})}/>
                            </fieldset>
                        }
                        <div className="row">
                            <div className="col-lg-12">
                                <fieldset className="form-group">
                                    <PredefinedDateRangePicker opens="left" drops="up"
                                                               startDate={this.state.startDate}
                                                               endDate={this.state.endDate}
                                                               onChange={(startDate, endDate) => this.updateCriteria({
                                                                   startDate,
                                                                   endDate
                                                               })}/>
                                    <div>
                                        <small className="text-muted">Диапазон даты доставки</small>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <fieldset className="form-group">
                                    <label className="custom-control custom-radio radio-inline">
                                        <input type="radio" className="custom-control-input"
                                               name="typeIdSearch"
                                               value=""
                                               checked={this.state.typeId === null}
                                               onChange={event => this.updateCriteria({typeId: null})}/>
                                        <span className="custom-control-indicator"/>
                                        Все
                                    </label>
                                    <label className="custom-control custom-radio radio-inline">
                                        <input type="radio" className="custom-control-input"
                                               name="typeIdSearch"
                                               value="1"
                                               checked={this.state.typeId === 1}
                                               onChange={event => this.updateCriteria({typeId: 1})}/>
                                        <span className="custom-control-indicator"/>
                                        Покупка
                                    </label>
                                    <label className="custom-control custom-radio radio-inline">
                                        <input type="radio" className="custom-control-input"
                                               name="typeIdSearch"
                                               value="2"
                                               checked={this.state.typeId === 2}
                                               onChange={event => this.updateCriteria({typeId: 2})}/>
                                        <span className="custom-control-indicator"/>
                                        Продажа
                                    </label>
                                </fieldset>
                            </div>
                        </div>
                        {
                            this.props.showAdvertsOnly &&
                            <div className="row">
                                <div className="col-lg-12">
                                    <fieldset className="form-group">
                                        <label className="custom-control custom-checkbox checkbox-inline">
                                            <input type="checkbox" className="custom-control-input"
                                                   checked={this.state.isAdvertsOnly}
                                                   onChange={event => this.updateCriteria({isAdvertsOnly: event.target.checked})}/>
                                            <span className="custom-control-indicator"/> Только из объявлений
                                        </label>
                                    </fieldset>
                                </div>
                            </div>
                        }
                    </form>
                </div>
                <div className="box-row">
                    <ActionLink className="widget-more-link"
                                onClick={() => this.resetFilters()}>
                        СБРОСИТЬ
                    </ActionLink>
                </div>
                <ProductsModal products={this.state.products}
                               show={this.state.showProductsModal}
                               onHide={() => this.setState({showProductsModal: false})}/>
            </div>
        );
    }

    updateCriteria(state) {
        const {onChange} = this.props;

        if (state.region)
            state.region = (state.region || {}).strictName;

        this.setState(state);

        if (onChange) {
            let criteria = {
                typeId: this.state.typeId,
                region: (this.state.region || {}).strictName,
                isPickupOnly: this.state.isPickupOnly,
                clientCompany: this.state.clientCompany,
                selectedProduct: this.state.selectedProduct,
                selectedProducts: this.state.selectedProducts,
                showUsedProducts: this.state.showUsedProducts,
                showNewProducts: this.state.showNewProducts,
                minPrice: this.state.minPrice,
                maxPrice: this.state.maxPrice,
                minCount: this.state.minCount,
                maxCount: this.state.maxCount,
                startDate: this.state.startDate,
                endDate: this.state.endDate,
                isAdvertsOnly: this.state.isAdvertsOnly
            };

            onChange({
                ...criteria,
                ...state
            });
        }
    }

    resetFilters() {
        const {onChange} = this.props;

        let criteria = {
            region: {},
            isPickupOnly: false,
            clientCompany: '',
            selectedProducts: [],
            showUsedProducts: false,
            showNewProducts: false,
            minPrice: '',
            maxPrice: '',
            minCount: '',
            maxCount: '',
            startDate: moment().add(-1, 'years').format(),
            endDate: moment().add(1, 'years').format()
        };

        this.setState(criteria);

        if (onChange) {
            criteria.region = criteria.region.strictName;
            onChange(criteria);
        }
    }
}

export default SearchForm;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/components/SearchForm.js